import TestimonialsSlider from './TestimonialsSlider';
import testimonials from '../../data/testimonials';

const template = (i) => `<div class="testimonials__item">
  <div class="testimonials__item__header">
    <div class="testimonials__item__header__discipline">Discipline: <br>${i.orderDiscipline}</div>
    <div class="testimonials__item__header__pages"><span>Pages <br>${i.orderPages}</span></div>
    <div class="testimonials__item__header__date">${i.createdAt}</div>
  </div>
  <div class="testimonials__item__body">${i.body}</div>
  <div class="testimonials__item__footer">customer's feedback (${i.customerId})</div>
</div>`;

__WMS__.utils.observeElement({
  element: '[data-testimonials-widget-js]',
  marginValue: 800,
  callback: () => {
    document.querySelector('[data-testimonials-widget-js]').removeChild(document.querySelector('.Loader'));
    const tmNodes = testimonials.map((tm) => template(tm)).join('');
    document.querySelector('[data-testimonials-widget-js]').insertAdjacentHTML('afterbegin', tmNodes);
    testimonials.forEach((tm, key) => {
      const bullet = document.createElement('button');
      bullet.classList.add('glide__bullet');
      bullet.setAttribute('data-glide-dir', `=${key}`);
      document.querySelector('.glide__bullets').appendChild(bullet);
    });
    TestimonialsSlider();
  },
});
